import React from 'react';
import styled, { css } from 'styled-components';

const getBackgroundColor = (value: number): string => {
  if (value === 100) {
    return '#149600';
  }

  if (value > 90) {
    return '#19B800';
  }
  if (value > 75) {
    return '#2DDB12';
  }
  if (value > 60) {
    return '#4EE237';
  }
  if (value > 40) {
    return '#97F289';
  }
  if (value > 20) {
    return '#FD8F97';
  }
  if (value > 10) {
    return '#FC626D';
  }

  return '#FB3D4B';
};
const dynamicAfter = (props: LabelProps & { emptyValue: boolean }) => {
  return props.emptyValue
    ? css`
        :after {
          font-size: 9px;

          content: '-';
        }
      `
    : props.helperText
    ? css`
        :after {
          font-size: 9px;

          content: ' % (${props.helperText})';
        }
      `
    : css`
        :after {
          font-size: 9px;

          content: ' %';
        }
      `;
};

const PillLabel = styled.p<LabelProps & { emptyValue: boolean }>`
  border-radius: 5px;
  color: white;
  background: ${({ value }) => getBackgroundColor(value)};
  padding: 8px;
  margin: 8px;
  margin-left: 0px;
  text-align: center;
  ${dynamicAfter}
`;

const Label = styled.p<LabelProps & { emptyValue: boolean }>`
  color: ${({ value }) => getBackgroundColor(value)};
  margin: 0;
  text-align: center;

  font-weight: bold;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    text-align: left;
  }
  ${dynamicAfter}
`;

interface LabelProps {
  value: number;
  helperText?: string;
}

interface PercentLabelProps extends LabelProps {
  withoutHelperText?: boolean;
  children: React.ReactNode;
}
export const PercentPillLabel = ({ children, value, helperText = '', withoutHelperText = false }: PercentLabelProps) => {
  const emptyValue = withoutHelperText && !value;

  return (
    <PillLabel emptyValue={emptyValue} value={value} helperText={helperText}>
      {!emptyValue ? children : null}
    </PillLabel>
  );
};

export const PercentLabel = ({ children, value, helperText = '', withoutHelperText = false }: PercentLabelProps) => {
  const emptyValue = withoutHelperText && !value;
  return (
    <Label emptyValue={emptyValue} value={value} helperText={helperText}>
      {!emptyValue ? children : null}
    </Label>
  );
};
